const resumeData = {
    name: 'Janarthani V Subramaniam',
    title: 'Full Stack Web Developer',
    email: `vs.janarthani@gmail.com`,
    phone: `510-516-2598`,
    location: `San Francisco Bay Area`,
    linkedin: `https://www.linkedin.com/in/janarthani-v-s/`,
    github: `https://github.com/vsjanarthani/`,
    shortintro: `Full Stack Web Developer with a passion for developing 
    apps that are fully functional, scalable and user-friendly.
     Life long learner and gardening enthusiast.`,
    aboutme: `I build scalable solutions with intutive UI & UX`,
    intro: {
        line1: `Thank you for showing interest in my portfolio!`,
        line2: `Hi, I'm Janarthani Subramaniam a.k.a Jana. I'm a Bay Area Resident, currently seeking opportunities near me in the field of web-development using JavaScript.`,
        line3: `I'm passionate about creating functional, scalable and mobile responsive web applications with intutive UI & UX. Other than coding I'm also passionate
        about gardening and hiking.`,
        line4: `I have worked in different sectors such as Order Management, Education, Event Planning and Taxation, through which i have acquired
        interpersonal skills, project management, problem solving and working well under pressure. I'm always looking to learn new things and to grow as a person.`,
        line5: `Checkout out the projects section to see my work or leave a message if you wish to contact me.`
    },
    project: [
        {
            title: `POKÉMON DRAFT GAME - FULL STACK | REST API | MVC`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480559/pokemon_ocj0q9.jpg`,
            description: `A simple game to draft a max of 6 Pokémon and build a team. Users can challenge other users to check who has the strongest team.`,
            builtwith: `Node.js (express.js, mysql2, sequelize, nodemon, dotenv, express-handlebars), JavaScript (ES6), Heroku, PokéAPI, Socket.io.`,
            github: `https://github.com/vsjanarthani/fullstack-pokemon-game.git`,
            deployed: `https://pokemon-fullstack.herokuapp.com/`,
        },
        {
            title: `CAMPUS CONNECT - MERN STACK | NOSQL - ODM | PWA`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480558/campus_connect_v09uzn.jpg`,
            description: `A mern stack app to connect Coding Bootcamp Alumni for networking purposes. Get latest updates, news, project collobraions or chat about the good old bootcamp days`,
            builtwith: `Node.js (express.js, mongoose, nodemon, dotenv, apollo-server-express, JWT), PWA, JavaScript (ES6), React, MongoDB, Heroku`,
            github: `https://github.com/Clayto30/campus-connect.git`,
            deployed: `https://jana-campus-connect.herokuapp.com/`,
        },
        {
            title: `EMPLOYEE PROFILE GENERATOR - BACKEND | OOP`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480558/Employee-profile-generator_vypp70.jpg`,
            description: `This is an apllication for generating employee profiles for a team. The application prompts for user input such as name, email id, emp id, 
            school, github username, role, office number etc to generate the team profile. After obtaining the user input, the application will generate a HTML file 
            that displays the employee data styled neatly.`,
            builtwith: `HTML, CSS, JavaScript(ES6), Node.js (Inquirer and Jest packages).`,
            github: `https://github.com/vsjanarthani/Employee-Profile-Generator.git`,
            deployed: `https://drive.google.com/file/d/1jQFgL2msM3HRR-pW9IqJ0aA0WHYgyPLE/view`,
        },
        {
            title: `WORD SEARCH APP - FRONT-END | THIRD PART API`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1623658848/samples/word-search_ax5x8v.jpg`,
            description: `Dictionary like app that provides an easy-to-navigate platform that enables users to search for different words and find their 
            definition, references and examples. This project also features “word of the day”, “word quiz”, “webpage translation” and saving favorite words`,
            builtwith: `HTML, CSS, JavaScript, third party APIs and collaborating with peers.`,
            github: `https://github.com/vsjanarthani/word-search.git`,
            deployed: `https://vsjanarthani.github.io/word-search/`,
        },
        {
            title: `TECH BLOG - FULL STACK | MVC | SQL - ORM`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480559/Tech-blog_g4mg3e.jpg`,
            description: `This is an application for creating Blog posts. The application allows users to create an account and post their blog posts. 
            Users can also edit/delete their own posts and leave comment on other's post after logging in. Anyone view the homepage which contains blog 
            posts posted by other users. Anyone can view individual posts and its comments as well. To perform other actions, login is required.`,
            builtwith: `Node.js (express-handlebars, mysql2, sequelize, nodemon, dotenv, bcrypt, express-session, connect-session-sequalize), HMTL, CSS, MDB, JavaScript, ES6, Heroku, Git`,
            github: `https://github.com/vsjanarthani/Tech-Blog-MVC.git`,
            deployed: `https://my-tech-blog-mvc.herokuapp.com/`,
        },
        {
            title: `WEATHER DASHBOARD - FRONT END | THIRD-PARTY API | LOCAL STORAGE`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480558/Weather-Dashboard_dqakau.jpg`,
            description: `The weather dashboard app allows the user to search for current weather and also 5 day forecast of a city. The data is fetched from openweathermap.org/api. 
            Last 5 searches are saved in local storage and displayed as button. Clicking on the button also fetches the weather forecast for that city.`,
            builtwith: `HTML, CSS, JavaScript, third party APIs, local storage.`,
            github: `https://github.com/vsjanarthani/weather-dashboard.git`,
            deployed: `https://vsjanarthani.github.io/weather-dashboard/`,
        },
        {
            title: `NOTE TAKER - REST APIS | LOCAL STORAGE`,
            image: `https://res.cloudinary.com/janarthani/image/upload/v1627480558/Note-Taker_wa7fzu.jpg`,
            description: `This is a simple note taker app created using express js. API routes are created for performing CRUD (Create, Read, Update and Delete) operations
             by the user via DOM elements.`,
            builtwith: `HTML, CSS, JavaScript (ES6), Node.js, express.js, local storage, heroku`,
            github: `https://github.com/vsjanarthani/Notes-Taker.git`,
            deployed: `https://note-taker-jana.herokuapp.com/notes`,
        },
    ],
    testimonials: [
        {
            name: `Sarah Durkin`,
            designation: `Head of Search at The Action Network | Product & Organic Growth`,
            testimonial: `Jana was a classmate in a Coding Bootcamp at UC Berkeley and my teammate on two of the program’s larger group projects. Jana was consistently 
            one of the most well-prepared and engaged students throughout the course—her questions were insightful, timely, and representative of her deeper grasp
             of the technologies and languages we were learning.
            I witnessed Jana’s remarkable ability to turn abstract ideas into technically sound solutions on our group projects. She consistently pushed our team to 
            meet and then exceed minimum requirements while supporting the team where needed, demonstrating her skills with Javascript, Node.js, Material-UI, SQL, Mongoose, 
            MongoDB, and more. A fast learner and dedicated to getting it right, I have no doubt Jana has a productive and exceptional Full Stack career ahead of her.`
        },
        {
            name: `Ajiesh Mathew`,
            designation: `Senior Manager - Global Business Operations at Oracle`,
            testimonial: `Janarthani was on the best team member I had,
             always on top of things. Understands the customer need and execute the tasks
              on time. She have an exceptional skill in managing people and very good on execution.`
        },
        {
            name: `Richard Charboneau`,
            designation: `Founder of the Mertic Group`,
            testimonial: `Jana was my go-to person while I was a transition manager at Symantec. She was very 
            accountable and responsible and could be counted on in situations where stakes were high or deadlines 
            were imminent. On more than one occasion Jana was the reason high dollar transactions were processed. 
            I truly hope I have the opportunity to work with her again.`
        },
        {
            name: `Srikanth Murugula`,
            designation: `Operations Manager at Genpact`,
            testimonial: `I have worked with Janarthani and also reported her few months. She was good at 
            client management, team management, leadership and decision making skills. She is expert and carries strong domain knowledge in OTC.`
        },
        {
            name: `Vijay Kumar M`,
            designation: `Assistant Manager - Logistics at Genpact`,
            testimonial: `I worked with Jana for 5+ yrs in a different team and I personally know her for more than 14yrs.
            She was one of the dynamic and out of the box thinker. Poses excellent operations management and Team management skills, 
            handled second level of escalations from customer/clients efficiently. Always passionate towards learning new skills.
            As a Team Lead she was one-stop-go-to person for any information for both internal Organisation and Client end.
            Maintained very good relationship with clients.
            Always tried to be different and innovative which are good for both process and organisation by connecting dots in the different processes.
            I strongly recommend her for her trustworthiness and quality of work.`
        },
        {
            name: `Yevgeniya Terlyuk`,
            designation: `Full Stack Web Developer`,
            testimonial: `We studied at the UC Berkley coding bootcamp together. Her knowledge in the field is superb. She was able to tackle any
             issue that was coming our way when we were working on the project together. She is always ready to help and give an advice. 
             I would recommend Jana 100%, she is an amazing full stack web developer!`
        },
    ],
    skills: [
        {
            id: 1,
            type: `Computer Languages`,
            avatar: `https://res.cloudinary.com/janarthani/image/upload/v1627365159/computer_inxkzq.gif`,
            skills: `HTML5, CSS3, JavaScript(ES6 & OOP), SQL, GraphQL`
        },
        {
            id: 2,
            type: `JS Framework | Packages`,
            avatar: `https://res.cloudinary.com/janarthani/image/upload/v1627362203/javascript_hqqpz7.gif`,
            skills: `Express.js, Inquirer, Jest, Moment.js, sequelize, Mongoose, React.js, express-handlebars, apollo-server, express-session, bcrypt,
            JSON web tokens, dotenv, Bootstrap, Material-UI, jQuery`
        },
        {
            id: 3,
            type: `Databases & Hosting platforms`,
            avatar: `https://res.cloudinary.com/janarthani/image/upload/v1627365129/github_zhho8g.gif`,
            skills: `MySQL, MongoDB, GitHub, Heroku, Netlify`
        },
        {
            id: 4,
            type: `Softskills`,
            avatar: `https://res.cloudinary.com/janarthani/image/upload/v1627365102/softskills_pqz80a.gif`,
            skills: `Planning & Organising, Team Management, Business Analysis, Leadership, Project Management`
        },
        {
            id: 5,
            type: `Human Languages`,
            avatar: `https://res.cloudinary.com/janarthani/image/upload/v1627365062/languages_oauuoi.gif`,
            skills: `English (read, write and speak), Tamil (read, write and speak), Hindi (speaking only), Kannada (speaking only)`
        },

    ]
}

export default resumeData